import { postAppleLogin } from './postAppleLogin';
import { postEmailLogin } from './postEmailLogin';
import { postFacebookLogin } from './postFacebookLogin';
import { postKakaoAccessToken } from './postKakaoAccessToken';
import { postKakaoLogin } from './postKakaoLogin';
import { postInvitationAccept } from './postInvitationAccept';
import { postNaverLogin } from './postNaverLogin';
import { postRecoverEmail } from './postRecoverEmail';
import { postRecoverPassword } from './postRecoverPassword';
import { postResetPassword } from './postResetPassword';
import { postTermsAgreementVerify } from './postTermsAgreementVerify';
import { postValidateEmailAuth } from './postValidateEmailAuth';
import { postValidatePasswordAuth } from './postValidatePasswordAuth';
import { postVerificationIssue } from './postVerificationIssue';
import { postVerificationValidate } from './postVerificationValidate';

export const authService = {
  postAppleLogin,
  postEmailLogin,
  postFacebookLogin,
  postInvitationAccept,
  postKakaoAccessToken,
  postKakaoLogin,
  postNaverLogin,
  postRecoverEmail,
  postRecoverPassword,
  postResetPassword,
  postTermsAgreementVerify,
  postValidateEmailAuth,
  postValidatePasswordAuth,
  postVerificationIssue,
  postVerificationValidate,
};
